import { useMutation } from "@tanstack/react-query";
import { useCartContext } from "app/providers/CartProvider";
import { toast } from "react-toastify";
import { api } from "shared/api";
import { ProductContext } from "shared/utils/productContext";

export const apiValidateVoucher = async ({
  voucher,
  model,
}: {
  voucher: string;
  model: string;
}) => {
  const res = await api().gersValidateDiscountCode(voucher, model);
  return res.data;
};

export const useVoucherCartAddition = () => {
  const {
    mutateAsync,
    status,
    reset: resetAddVoucherToCart,
  } = useMutation(apiValidateVoucher);
  const { setVoucher, getCart } = useCartContext();

  const cart = getCart();
  const productContext =
    cart.products.length > 0
      ? ProductContext.DoorContext
      : ProductContext.StandardProductContext;

  const handleVoucherTypeOnAddition = (
    voucherData: any,
    productContext: string,
    discountCodeInitialised: boolean,
  ): boolean => {
    if (
      // It's not empty
      (voucherData !== "" &&
        // It's either a door voucher and the cart has doors
        voucherData.applyToOrder &&
        productContext === ProductContext.DoorContext) ||
      // It's either a std product voucher and the cart has std products
      (voucherData.applyToStandardOrder &&
        productContext === ProductContext.StandardProductContext)
    ) {
      // Set the correct voucher
      setVoucher(voucherData, discountCodeInitialised);

      // Show success message
      if (!discountCodeInitialised) {
        toast.success("Voucher is toegevoegd!");
      }
      return true;
    } else {
      // Show error message
      toast.error("Voucher is ongeldig!");
      return false;
    }
  };

  const addVoucherToCart = async (
    voucher: string,
    model: string,
    discountCodeInitialised = false,
  ): Promise<boolean> => {
    try {
      const voucherData = await mutateAsync({ voucher, model });

      const success = handleVoucherTypeOnAddition(
        voucherData,
        productContext,
        discountCodeInitialised,
      );
      return success;
    } catch (error: any) {
      toast.error("Voucher is ongeldig!");
      return false;
    }
  };

  return { addVoucherToCart, status, resetAddVoucherToCart };
};
